module.exports = __webpack_public_path__ + "static/media/icn_progress.6db3573d.svg";